import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/Box (and its Hbox/Vbox variants).
// A flex container; any extra props are spread onto the underlying div's style.
const useStyles = makeStyles(
  {
    root: {
      display: 'flex',
    },
    split: {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  { name: 'RSFBox' },
)

export function Box({
  className,
  classes,
  split = false,
  children,
  style,
  align = 'center',
  justify = 'flex-start',
  ...other
}) {
  classes = useStyles({ classes })
  return (
    <div
      className={clsx(classes.root, className, { [classes.split]: split })}
      style={{
        alignItems: align,
        justifyContent: justify,
        ...other,
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export function Hbox(props) {
  return <Box {...props} flexDirection="row" />
}

export function Vbox(props) {
  return <Box {...props} flexDirection="column" />
}

export default Box
